.ReactModal__Body--open {
  overflow: hidden;
}

.modal-wrapper {
  position: relative;
  width: 100%;

  .modal-arrow {
    cursor: pointer;
    position: fixed;
    width: 100px;
    height: 140px;
    display: flex;
    align-items: center;
    background-color: var(--base_color2);
    top: 40%;
    transition: all 0.2s ease-out;
    color: var(--gray_dark2);

    &.arrow-next {
      justify-content: flex-end;
      right: calc(15% - 36px);
      z-index: -140;
      border-top-right-radius: 999em;
      border-bottom-right-radius: 999em;
      padding-right: 6px;

      svg {
        margin-left: 8px;
      }

      &:hover {
        right: calc(15% - 75px);
      }
    }

    &.arrow-previous {
      padding-left: 6px;
      justify-content: flex-start;
      z-index: -1;
      left: calc(15% - 34px);
      border-top-left-radius: 999em;
      border-bottom-left-radius: 999em;

      svg {
        margin-right: 4px;
      }

      &:hover {
        left: calc(15% - 100px);
      }
    }
  }
}
